import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import {
  Card,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Button,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import Label from "../Label";
import IconButton from "@material-ui/core/IconButton";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { sentenceCase } from "change-case";
import ModifyTaskStateModal from "../_dashboard/tareas/ModifyTaskStateModal";
import AgregarSubTareaDialog from "./AgregarSubTareaDialog";
import EditarSubTareaDialog from "./EditarSubTareaDialog";
import { useSelector } from "react-redux";
import moment from "moment";
import { subtareasApi } from "src/services/subtareasApi";
import { AlertaModalV2 } from "../AlertaSwall";
import { useSnackbar } from "src/components/snackbar";
import { tareasApi } from "src/services/tareasApi";
import { TablaHead } from "src/components/_dashboard/tablas";
import BarraSeleccionSubtareas from "./BarraSeleccionSubtareas";
import useSeleccionSubtareas from "./hooks/useSeleccionSubtareas";

const TABLE_HEAD = [
  { id: "nombre", label: "Nombre", alignRight: false },
  { id: "fechaInicio", label: "Fecha Inicio", alignRight: false },
  { id: "fechaTermino", label: "Fecha Término", alignRight: false },
  { id: "estado", label: "Estado", alignRight: false },
  { id: "acciones", label: "Acciones", alignRight: false },
];

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  hidden: {
    display: "none",
  },
});

export default function SubTareasDialog(props) {
  const { open, setOpen, tarea } = props;
  const { empleado: user } = useSelector((state) => state.auth.user);
  const classes = useStyles();
  const [showModifyTaskState, setShowModifyTaskState] = useState(false);
  const [selectedTask, setSelectedTask] = useState();

  const { data: subtareas = [] } = subtareasApi.useGetSubtareasTareaQuery(
    tarea.id,
  );

  const [actualizarEstadoSubtarea] =
    subtareasApi.useUpdateEstadoSubtareaMutation();
  const [eliminarSubtarea] = subtareasApi.useDeleteSubtareaMutation();
  const [actualizarEstadoTarea] = tareasApi.useUpdateCambiaEstadoMutation();

  const {
    subTareasSeleccionadas,
    puedeSeleccionar,
    subtareasSeleccionables,
    puedeModificarSubtarea,
    headLabel,
    handleSelectAllClick,
    estaSeleccionada,
    alternarSeleccion,
    handleDeleteLista,
  } = useSeleccionSubtareas({ tarea, subtareas, columnas: TABLE_HEAD });

  const [mostrarAgregar, setMostrarAgregar] = useState(false);

  const [selectedSubTaskEdit, setSelectedSubTaskEdit] = useState(null);
  const [mostrarEditar, setMostrarEditar] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClose = () => {
    setOpen(false);
  };

  const handleChangeTaskState = (id) => {
    const selectedTaskAux = subtareas.find((t) => t.id === id);
    setSelectedTask(selectedTaskAux);
    setShowModifyTaskState(true);
  };

  const doChangeTaskState = (newState) => {
    if (selectedTask.estado === newState) return setShowModifyTaskState(false);
    actualizarEstadoSubtarea({
      id: selectedTask.id,
      body: {
        estado: newState,
      },
    })
      .unwrap()
      .then(() => {
        enqueueSnackbar("Subtarea actualizada", {
          variant: "success",
        });
      })
      .catch(() => {
        enqueueSnackbar("Error en el servidor", {
          variant: "error",
        });
      });
    setShowModifyTaskState(false);
  };

  const handleDelete = (id) => {
    AlertaModalV2({
      title: "¿Quiere eliminar la subtarea?",
      text: "La subtarea sera eliminada, ¿Está seguro?",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      icon: "warning",
    })
      .fire()
      .then((result) => {
        if (result.isConfirmed) {
          eliminarSubtarea(id)
            .unwrap()
            .then(() => {
              enqueueSnackbar("Subtarea eliminada", {
                variant: "success",
              });
            })
            .catch((error) => {
              // Mismo motivo que en el lote: DELETE /subtareas/:id devuelve 403, 404 y 409
              // con su mensaje, y el genérico los tapaba.
              enqueueSnackbar(error?.data?.message || "Error en el servidor", {
                variant: "error",
              });
            });
        }
      });
  };

  useEffect(() => {
    if (tarea.estado === "PENDIENTE" && tarea.refEmpleado === user.rut) {
      actualizarEstadoTarea({
        id: tarea.id,
        body: {
          estado: "EN PROCESO",
          fechaTermino: "",
        },
      }).unwrap();
    }
  }, [
    tarea.estado,
    tarea.refEmpleado,
    tarea.id,
    user.rut,
    actualizarEstadoTarea,
  ]);

  return (
    <Dialog open={open} fullWidth maxWidth="md" id="dialogSubtarea">
      <DialogTitle>Subtareas</DialogTitle>
      <DialogContent>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Button
            variant="contained"
            startIcon={<Icon icon={plusFill} />}
            onClick={() => {
              setMostrarAgregar(true);
            }}
          >
            Agregar SubTarea
          </Button>
        </Stack>

        <Card style={{ padding: "1rem" }}>
          {puedeSeleccionar && (
            <BarraSeleccionSubtareas
              cantidad={subTareasSeleccionadas.length}
              onEliminar={handleDeleteLista}
            />
          )}

          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TablaHead
                headLabel={headLabel}
                // La tabla no ordena: el encabezado compartido siempre llama a este
                // handler al hacer clic en una columna, así que se le da uno vacío.
                onRequestSort={() => {}}
                select={puedeSeleccionar}
                rowCount={subtareasSeleccionables.length}
                selectedRows={subTareasSeleccionadas}
                handleSelectAllClick={handleSelectAllClick}
              />
              <TableBody>
                {subtareas &&
                  subtareas.map((row, idx) => (
                    <TableRow key={idx}>
                      {/* Las filas siempre pintan esta celda para no descuadrar las
                          columnas: sin casilla cuando la tarea está cerrada o cuando la
                          subtarea ya está terminada, que tampoco se puede eliminar. */}
                      {!puedeModificarSubtarea(row) ? (
                        <TableCell></TableCell>
                      ) : (
                        <TableCell padding="checkbox">
                          <Checkbox
                            checked={estaSeleccionada(row)}
                            onChange={(event) =>
                              alternarSeleccion(row, event.target.checked)
                            }
                          />
                        </TableCell>
                      )}

                      <TableCell component="th" scope="row">
                        {row.nombre}
                      </TableCell>
                      <TableCell>
                        {row.fechaInicio === ""
                          ? row.fechaInicio
                          : moment(row.fechaInicio, "YYYY/MM/DD").format(
                              "DD/MM/YYYY",
                            )}
                      </TableCell>
                      <TableCell>
                        {row.fechaTermino === ""
                          ? row.fechaTermino
                          : moment(row.fechaTermino, "YYYY/MM/DD").format(
                              "DD/MM/YYYY",
                            )}
                      </TableCell>
                      <TableCell onClick={() => handleChangeTaskState(row.id)}>
                        <Label
                          onClick={() => handleChangeTaskState(row.id)}
                          style={{ cursor: "pointer" }}
                          variant="ghost"
                          color={
                            (row.estado === "PENDIENTE" && "error") ||
                            (row.estado === "EN PROCESO" && "warning") ||
                            (row.estado === "TERMINADA" && "success") ||
                            "info"
                          }
                        >
                          {sentenceCase(row.estado)}
                        </Label>
                      </TableCell>
                      <TableCell>
                        {!puedeModificarSubtarea(row) ? (
                          <></>
                        ) : (
                          <React.Fragment>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                setSelectedSubTaskEdit(row);
                                setMostrarEditar(true);
                              }}
                            >
                              <FontAwesomeIcon icon={faEdit} />
                            </IconButton>
                            <IconButton
                              color="error"
                              onClick={() => {
                                handleDelete(row.id);
                              }}
                            >
                              <FontAwesomeIcon icon={faTrash} />
                            </IconButton>
                          </React.Fragment>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>

            {selectedTask && (
              <ModifyTaskStateModal
                task={selectedTask}
                onSubmit={doChangeTaskState}
                onClose={() => setShowModifyTaskState(false)}
                states={[
                  "PENDIENTE",
                  "EN PROCESO",
                  "OBSERVADA SII",
                  "TERMINADA",
                ]}
                open={showModifyTaskState}
                cargandoDatos={false}
              />
            )}
          </TableContainer>
        </Card>

        {mostrarAgregar && (
          <AgregarSubTareaDialog
            open={mostrarAgregar}
            setOpen={setMostrarAgregar}
            tarea={tarea}
          />
        )}
        {mostrarEditar && (
          <EditarSubTareaDialog
            open={mostrarEditar}
            setOpen={setMostrarEditar}
            subTarea={selectedSubTaskEdit}
            tarea={tarea}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}
